import { FC } from "react";
import { IProps } from "./types";
import styles from "./styles.module.scss";
import AmountInput from "../AmountInput";

const EditableMacroIconItem: FC<IProps> = ({
  title,
  icon,
  iconBackgroundCOlor,
  value,
  onChangeValue,
}): JSX.Element => {
  return (
    <div className={styles.wrapper}>
      <AmountInput
        value={value}
        onChange={(e: any) => onChangeValue(e.target.value)}
        wrapperStyles={styles.input}
      />
      <div className={styles.rowContainer}>
        <div
          style={{ backgroundColor: iconBackgroundCOlor }}
          className={styles.iconWrapper}
        >
          {icon}
        </div>

        <span className={styles.title}>{title}</span>
      </div>
    </div>
  );
};

export default EditableMacroIconItem;
